import {
  AISparkleIcon,
  CloseDefaultIcon,
  IconComponent,
  InfoIcon,
  PlansIcon,
  UpdatesIcon,
  UpgradeIcon,
  SitesStackIcon,
  UserAccessIcon,
  WarningCircleIcon,
  WebflowIcon,
} from '@packages/systems/spring';
import {KnockButtonAction} from './KnockButtonAction';

export const knockGuideIconMap: Record<string, IconComponent> = {
  AISparkle: AISparkleIcon,
  Info: InfoIcon,
  Plans: PlansIcon,
  SitesStack: SitesStackIcon,
  Updates: UpdatesIcon,
  Upgrade: UpgradeIcon,
  UserAccess: UserAccessIcon,
  WarningCircle: WarningCircleIcon,
  Webflow: WebflowIcon,
} as const;

export const knockIconMap: Record<string, IconComponent> = {
  ...knockGuideIconMap,
  [KnockButtonAction.Dismiss]: CloseDefaultIcon,
} as const;
